import * as React from 'react'
import './index.scss'

export interface IProps {
  label: string
  onRemove: () => void
}

export const RemovableOptionSelect: React.FC<IProps> = ({ label, onRemove }: IProps) => (
  <div className='option-select-container'>
    <span className='option-remove-icon' aria-hidden={true} onClick={onRemove}>
      x
    </span>
    <span className='option-label'>{label}</span>
  </div>
)
